import { IServiceProvider } from "angular";
import { machineConfigurationCellClass } from "../../shared/components/machineConfigurationCellClass";
import { ColDef } from "../../../records/grids/columns/colDef";

export const vsServiceName = "machineConfigurationCellClassThreeRivers";
export const vsProviderName = `${vsServiceName}Provider`;

export type gridCellClass = (cellClassParams: any) => string | string[];

export class MachineConfigurationCellClassServiceProvider
  implements IServiceProvider
{
  $get = [
    "environment",
    (environment: any) =>
      new MachineConfigurationCellClassService(
        machineConfigurationCellClass(
          environment.Date,
          "CurrentConfiguration",
          "Date"
        )
      ),
  ];
}

export class MachineConfigurationCellClassService {
  constructor(private readonly machineConfigurationCellClass: gridCellClass) {}

  styleColumns(columns: ColDef[] | undefined, showStyle: boolean) {
    columns?.forEach(
      (c) =>
        (c.cellClass = showStyle
          ? this.machineConfigurationCellClass
          : undefined)
    );
  }
}
